var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, hasMany } from '@ember-data/model';
import { computed } from '@ember/object';
import { A } from '@ember/array';
export let OBJECT_TYPE = /*#__PURE__*/function (OBJECT_TYPE) {
  OBJECT_TYPE["ITEM_VARIATION"] = "ITEM_VARIATION";
  OBJECT_TYPE["LOCATION"] = "LOCATION";
  OBJECT_TYPE["INVENTORY_LEVEL"] = "INVENTORY_LEVEL";
  return OBJECT_TYPE;
}({});
var ObjectDeletedType = /*#__PURE__*/function (ObjectDeletedType) {
  ObjectDeletedType[ObjectDeletedType["FALSE"] = 0] = "FALSE";
  ObjectDeletedType[ObjectDeletedType["TRUE"] = 1] = "TRUE";
  return ObjectDeletedType;
}(ObjectDeletedType || {});
var ObjectDisabledType = /*#__PURE__*/function (ObjectDisabledType) {
  ObjectDisabledType[ObjectDisabledType["FALSE"] = 0] = "FALSE";
  ObjectDisabledType[ObjectDisabledType["TRUE"] = 1] = "TRUE";
  return ObjectDisabledType;
}(ObjectDisabledType || {});
let PlatformObject = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('json-or-value'), _dec5 = attr('number'), _dec6 = attr('number'), _dec7 = attr('json-or-value'), _dec8 = attr('number'), _dec9 = attr('number'), _dec10 = attr('date'), _dec11 = attr('date'), _dec12 = attr('date'), _dec13 = hasMany('channels/object-map', {
  async: false
}), _dec14 = computed('hasObjectMaps', 'objectMaps.@each.errorTypeObjectMapAcknowledgmentErrors'), _dec15 = computed('hasObjectMaps', 'objectMaps.@each.warningTypeObjectMapAcknowledgmentWarnings'), _dec16 = computed('aggregatedErrorTypeObjectMapAcknowledgmentErrors.@each.isResolvableInSquareError'), _dec17 = computed('aggregatedErrorTypeObjectMapAcknowledgmentErrors.@each.isSystemError'), _dec18 = computed('aggregatedErrorTypeObjectMapAcknowledgmentErrors.@each.fields'), _dec19 = computed('aggregatedWarningTypeObjectMapAcknowledgmentErrors.@each.fields'), _dec20 = computed('hasObjectMaps', 'objectMaps'), _dec21 = computed('hasObjectMaps', 'objectMaps'), _dec22 = computed('objectMaps.length'), _dec23 = computed('objectData.image_uris.length'), _class = class PlatformObject extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantId", _descriptor, this);
    _initializerDefineProperty(this, "objectId", _descriptor2, this);
    _initializerDefineProperty(this, "objectType", _descriptor3, this);
    _initializerDefineProperty(this, "objectData", _descriptor4, this);
    _initializerDefineProperty(this, "objectDeleted", _descriptor5, this);
    _initializerDefineProperty(this, "objectDisabled", _descriptor6, this);
    _initializerDefineProperty(this, "metaData", _descriptor7, this);
    _initializerDefineProperty(this, "version", _descriptor8, this);
    _initializerDefineProperty(this, "revision", _descriptor9, this);
    _initializerDefineProperty(this, "createdAt", _descriptor10, this);
    _initializerDefineProperty(this, "deletedAt", _descriptor11, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor12, this);
    _initializerDefineProperty(this, "objectMaps", _descriptor13, this);
  }
  get aggregatedErrorTypeObjectMapAcknowledgmentErrors() {
    if (!this.hasObjectMaps) {
      return A([]);
    }
    return A(this.objectMaps?.reduce((accumulator, objectMap) => {
      return [...accumulator, ...objectMap.errorTypeObjectMapAcknowledgmentErrors];
    }, [])).uniqBy('errorProblem').toArray();
  }
  get aggregatedWarningTypeObjectMapAcknowledgmentErrors() {
    if (!this.hasObjectMaps) {
      return A([]);
    }
    return A(this.objectMaps?.reduce((accumulator, objectMap) => {
      return [...accumulator, ...objectMap.warningTypeObjectMapAcknowledgmentWarnings];
    }, [])).uniqBy('errorProblem').toArray();
  }
  get userResolvableAggregatedObjectMapAcknowledgmentErrors() {
    return this.aggregatedErrorTypeObjectMapAcknowledgmentErrors.filter(error => {
      return error.isResolvableInSquareError;
    });
  }
  get systemResolvableAggregatedObjectMapAcknowledgmentErrors() {
    return A(this.aggregatedErrorTypeObjectMapAcknowledgmentErrors).filterBy('isOccurredBySystem');
  }
  get uniqueObjectMapAcknowledgmentErrorFields() {
    if (!this.aggregatedErrorTypeObjectMapAcknowledgmentErrors) {
      return A([]);
    }
    return A(this.aggregatedErrorTypeObjectMapAcknowledgmentErrors.reduce((accumulator, objectMapAcknowledgmentError) => {
      return [...accumulator, ...objectMapAcknowledgmentError.fields];
    }, [])).uniqBy('field').toArray();
  }
  get uniqueObjectMapAcknowledgmentWarningFields() {
    if (!this.aggregatedWarningTypeObjectMapAcknowledgmentErrors) {
      return [];
    }
    return A(this.aggregatedWarningTypeObjectMapAcknowledgmentErrors?.reduce((accumulator, objectMapAcknowledgmentWarning) => {
      return [...accumulator, ...objectMapAcknowledgmentWarning.fields];
    }, [])).uniqBy('field').toArray();
  }
  get hasObjectMapErrors() {
    if (!this.hasObjectMaps) {
      return false;
    }
    return this.objectMaps.any(objectMap => objectMap.isAcknowledgementStatusSystemError || objectMap.isAcknowledgementStatusUserError);
  }
  get hasObjectMapWarnings() {
    if (!this.hasObjectMaps) {
      return false;
    }
    return this.objectMaps.any(objectMap => objectMap.isAcknowledgementStatusUserWarning);
  }
  get hasObjectMaps() {
    return this.objectMaps?.toArray().length > 0;
  }
  get hasImageUris() {
    if (typeof this.objectData === 'string') {
      return false;
    }
    return this.objectData?.image_uris?.length > 0;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "objectId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "objectType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "objectData", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "objectDeleted", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "objectDisabled", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "metaData", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "version", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "revision", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "deletedAt", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "objectMaps", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "aggregatedErrorTypeObjectMapAcknowledgmentErrors", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "aggregatedErrorTypeObjectMapAcknowledgmentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "aggregatedWarningTypeObjectMapAcknowledgmentErrors", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "aggregatedWarningTypeObjectMapAcknowledgmentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userResolvableAggregatedObjectMapAcknowledgmentErrors", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "userResolvableAggregatedObjectMapAcknowledgmentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "systemResolvableAggregatedObjectMapAcknowledgmentErrors", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "systemResolvableAggregatedObjectMapAcknowledgmentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "uniqueObjectMapAcknowledgmentErrorFields", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "uniqueObjectMapAcknowledgmentErrorFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "uniqueObjectMapAcknowledgmentWarningFields", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "uniqueObjectMapAcknowledgmentWarningFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasObjectMapErrors", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "hasObjectMapErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasObjectMapWarnings", [_dec21], Object.getOwnPropertyDescriptor(_class.prototype, "hasObjectMapWarnings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasObjectMaps", [_dec22], Object.getOwnPropertyDescriptor(_class.prototype, "hasObjectMaps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasImageUris", [_dec23], Object.getOwnPropertyDescriptor(_class.prototype, "hasImageUris"), _class.prototype), _class);
export { PlatformObject as default };